module.exports = __webpack_public_path__ + "img/Superb_sword_12.afe52e6c.png";